import { ClearRectangle } from './shapes/ClearRectangle';
import { RoiHandlerBase } from './RoiHandlerBase';

export class RoiHandlerWysiwyg extends RoiHandlerBase {
  init (surface) {
    const shape = new ClearRectangle(0, 0, surface.width, surface.height);

    setTimeout(() => {
      this.signalUserActionComplete(shape);

      RoiHandlerBase.normalizeAndOffset(shape, this.settings.viewportInfo);

      this.finish(shape);
    });
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/RoiHandlerWysiwyg.js